import Secrets from '@yumi/secrets';

Object.assign(window, { Secrets });
